import React from "react";
import { connect } from "react-redux";

// component imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DocumentReviewListTag = ({
  type,
  perDepartmentAnalysisIndex,
  activateClauses,
  fullAnalysis,
  dataLoading,
}) => {
  const _getNumberOfClauses = () => {
    if (
      perDepartmentAnalysisIndex &&
      perDepartmentAnalysisIndex[type.department]
    ) {
      return perDepartmentAnalysisIndex[type.department].length;
    }
    if (fullAnalysis && type.department === "Full") {
      return fullAnalysis.length;
    }
    return 0;
  };

  const NumberOfClauses = _getNumberOfClauses();

  return (
    <div
      onClick={() => activateClauses(type, NumberOfClauses)}
      tabIndex="0"
      role="button"
      onKeyDown={() => {}}
      className="documentreviewlist-tag">
      <div className="documentreviewlist-tag-head">
        <div>
          <span className="documentreviewlist-tag-head-icon">
            <FontAwesomeIcon
              icon={["far", type.icon]}
              className="documentreviewlist-tag-head-icon-fi"
            />
          </span>
          <span className="documentreviewlist-tag-head-title">
            {type.title}
          </span>
        </div>
        {!dataLoading && (
          <div className="documentreviewlist-tag-head-ctype">
            {NumberOfClauses}
            {"  "}
            {NumberOfClauses === 1 ? "insight" : "insights"}
          </div>
        )}
      </div>
      <div className="documentreviewlist-tag-body">{type.description}</div>
    </div>
  );
};

const mapStateToProps = ({
  MetalensStore: { perDepartmentAnalysisIndex, fullAnalysis },
}) => ({
  perDepartmentAnalysisIndex,
  fullAnalysis,
});

export default connect(mapStateToProps)(DocumentReviewListTag);



// WEBPACK FOOTER //
// ./src/components/QuickReview/DocumentReviewSection/DocumentReviewListing/DocumentReviewListTag.js